module.exports = __webpack_public_path__ + "assets/img/Main.bedb44fb.svg";